import gql from 'graphql-tag';

export default gql`
    mutation RemoveBox($input: RemoveBoxInput) {
        removeBox(input: $input) {
            errors
        }
    }
`;
